export const KneeMovePassiveText = {
  values: [
    { value: 'KneeMovePassive', text: 'Ja', score: 1 },
    { value: 'KneeMovePassive', text: 'Nei', score: 0 },
  ],
};
